<template>
    <div id="create-task-form">
        <div class="row">
            <div class="input title-input">
                <div class="label">Title</div>
                <a-input class="classic-new-input" v-model:value="form.title" placeholder="Task #" />
            </div>
            <div class="input priority-input">
                <div class="label">Priority</div>
                <a-select class="classic-new-select" v-model:value="form.priority" :options="options" />
            </div>
        </div>
        <div class="row">
            <quill-editor
                style="max-height: 20%; width: 100%"
                class="quill-editor"
                :options="editorOption"
                v-model="form.description"
                placeholder="Task Description"
            />
        </div>
        <div class="row">
            <div class="checklist-data">
                <div style="display: flex; align-items: center; gap: 20px" v-if="form.checklist.length > 0">
                    <div style="font-weight: bold; font-size: 16px; margin-right: 20px">Checklist</div>
                    <div style="width: 200px">
                        <a-progress
                            :stroke-color="{
                                '0%': 'ec4b1d',
                                '100%': 'ec4b1d',
                            }"
                            :percent="
                                (100 / form.checklist.length) * form.checklist.filter((c) => c.isCompleted).length
                            "
                            :show-info="false"
                        />
                    </div>
                    <div style="width: 200px">
                        Completed: {{ form.checklist.filter((c) => c.isCompleted).length }} out of
                        {{ form.checklist.length }}
                    </div>
                </div>
                <div style="margin-top: 10px; display: flex; gap: 10px; flex-direction: column">
                    <div
                        style="display: flex; align-items: center; justify-content: flex-start; user-select: none"
                        v-for="(checkbox, index) of form.checklist"
                    >
                        <div style="display: flex; align-items: center; gap: 10px">
                            <a-checkbox class="kanban-checkbox large" v-model="checkbox.isCompleted" />
                            <input
                                style="
                                    width: 300px;
                                    border: none;
                                    outline: none;
                                    background: #f1f1f1;
                                    border-radius: 4px;
                                    padding: 3px 10px;
                                "
                                v-model="checkbox.title"
                            />
                        </div>
                        <div class="material-icons" @click="deleteCheckbox(index)">close</div>
                    </div>
                </div>
                <div
                    style="margin-top: 10px; color: #ec4b1d; font-weight: bold; cursor: pointer"
                    @click="addNewCheckBox"
                >
                    {{ !form.checklist.length ? "New Checklist" : "Add" }}
                </div>
            </div>
        </div>

        <div class="row">
            <div class="attach-files">
                <div class="text">
                    <div class="material-icons">attachment</div>
                    <div>Attach Files</div>
                </div>
                <div class="logo"><s3Logo /></div>
            </div>
        </div>
        <div class="user-assigne">
            <div class="input" style="width: 100%">
                <div class="label">Assignee</div>
                <div class="user-assigne-container">
                    <a-select
                        class="select-multiple"
                        v-model:value="form.assigneeIds"
                        mode="multiple"
                        :options="users"
                    ></a-select>
                    <div class="assigne-user-options">
                        <div class="assigne-option" @click="openAssigne('owner')">Owner</div>
                        <div class="assigne-option" @click="openAssigne('collaborators')">Collaborators</div>
                        <div class="assigne-option" @click="openAssigne('followers')">Followers</div>
                    </div>
                </div>
            </div>
            <div
                class="input user-assigne-owner"
                style="width: 100%"
                :style="{ height: assigneOptions['owner'] ? '95px' : '0px' }"
            >
                <div class="row-bracket"></div>
                <div class="label">Owner</div>
                <div class="user-assigne-container">
                    <a-select class="select-multiple" v-model:value="form.ownerId" :options="users"></a-select>
                </div>
            </div>
            <div
                class="input user-assigne-collaborators"
                style="width: 100%"
                :style="{ height: assigneOptions['collaborators'] ? '95px' : '0px' }"
            >
                <div class="row-bracket"></div>
                <div class="label">Collaborators</div>
                <div class="user-assigne-container">
                    <a-select
                        class="select-multiple"
                        v-model:value="form.collaboratorIds"
                        mode="multiple"
                        :options="users"
                    ></a-select>
                </div>
            </div>
            <div
                class="input user-assigne-followers"
                style="width: 100%"
                :style="{ height: assigneOptions['followers'] ? '95px' : '0px' }"
            >
                <div class="row-bracket"></div>
                <div class="label">Followers</div>
                <div class="user-assigne-container">
                    <a-select
                        class="select-multiple"
                        v-model:value="form.followerIds"
                        mode="multiple"
                        :options="users"
                    ></a-select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="input">
                <div class="label">Start Date</div>
                <div><a-date-picker v-model="form.startDate" /></div>
            </div>
            <div class="input">
                <div class="label">End Date</div>
                <div><a-date-picker v-model="form.endDate" /></div>
            </div>
        </div>
        <div class="row-bracket"></div>
        <div class="row">
            <div class="checklist-data">
                <div
                    style="display: flex; align-items: center; gap: 20px"
                    v-if="form.subTasks.filter((c) => c.isCompleted && !c.isExits).length > 0"
                >
                    <div style="font-weight: bold; font-size: 16px; margin-right: 20px">SubTasks</div>
                    <div style="width: 200px">
                        <a-progress
                            :stroke-color="{
                                '0%': 'ec4b1d',
                                '100%': 'ec4b1d',
                            }"
                            :percent="(100 / form.subTasks.length) * form.subTasks.filter((c) => c.isCompleted).length"
                            :show-info="false"
                        />
                    </div>
                    <div style="width: 200px">
                        Completed: {{ form.subTasks.filter((c) => c.isCompleted).length }} out of
                        {{ form.subTasks.filter((c) => c.isCompleted && !c.isExits).length }}
                    </div>
                </div>
                <div
                    style="margin-top: 10px; display: flex; gap: 10px; flex-direction: column"
                    v-if="form.subTasks.length > 0"
                >
                    <div v-for="(subtask, index) of form.subTasks">
                        <div
                            v-if="!subtask.isExits"
                            style="
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                user-select: none;
                                gap: 20px;
                            "
                        >
                            <div style="display: flex; align-items: center; gap: 10px; width: 100%">
                                <a-checkbox class="kanban-checkbox large" v-model="subtask.completed" />
                                <a-input
                                    class="classic-new-input"
                                    v-model:value="subtask.title"
                                    placeholder="SubTask Title"
                                />
                            </div>
                            <div style="width: 100%">
                                <a-select
                                    style="width: 100%"
                                    class="select-multiple"
                                    v-model:value="subtask.assignees"
                                    :options="users"
                                    placeholder="Assignee"
                                ></a-select>
                            </div>
                            <div class="material-icons" @click="deleteSubtask(index)">close</div>
                        </div>
                        <div
                            style="
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                user-select: none;
                                gap: 20px;
                            "
                            v-else
                        >
                            <div style="width: 100%">
                                <a-select
                                    style="width: 100%"
                                    class="select-multiple"
                                    v-model:value="subtask.taskId"
                                    :options="users"
                                    placeholder="Assignee"
                                ></a-select>
                            </div>
                            <div class="material-icons" @click="deleteSubtask(index)">close</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div
                        style="margin-top: 10px; color: #ec4b1d; font-weight: bold; cursor: pointer"
                        @click="addNewSubtask(false)"
                    >
                        {{ "Add SubTasks" }}
                    </div>
                    <div
                        style="margin-top: 10px; color: #ec4b1d; font-weight: bold; cursor: pointer"
                        @click="addNewSubtask(true)"
                    >
                        {{ "Add Exits SubTasks" }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import s3Logo from "./svg/S3.vue";
import { mapState, mapActions } from "vuex";
export default {
    name: "CreateTaskForm",
    components: { s3Logo },
    props: {
        details: {
            type: Object,
            default: () => ({
                taskId: null,
            }),
        },
    },
    data: () => ({
        form:{
            title: null,
            description: null,
            priority: "low",
            checklist: [],
            assigneeIds: [],
            ownerId: null,
            collaboratorIds: [],
            followerIds: [],
            subTasks: [],
            startDate: null,
            endDate: null,
            workflowId: null,
            pipelineStageId: null,
            color: null,
        },
        assigneOptions: {
            owner: false,
            collaborators: false,
            followers: false,
        },
        editorOption: {
            theme: "snow",
            modules: {
                toolbar: [
                    ["bold", "italic", "underline", "strike"],
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ color: [] }, { background: [] }],
                    [{ align: [] }],
                    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                    ["link"],
                ],
            },
        },
        options: [
            {
                value: "low",
                label: "Low",
            },
            {
                value: "medium",
                label: "Medium",
            },
            {
                value: "high",
                label: "High",
            },
        ],
        checked: true,
    }),
    computed: {
        ...mapState({
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc.push({
                        value: user._id,
                        label: user.name,
                    });
                    return acc;
                }, []),
            defaultWorkflow: (state) => state.tasks.defaultWorkflow,
        }),
    },
    methods: {
        ...mapActions({
            getTaskDetail: "tasks/getTaskDetail",
        }),
        addNewCheckBox() {
            if (
                this.form.checklist[this.form.checklist.length - 1] &&
                !this.form.checklist[this.form.checklist.length - 1].title
            ) {
                this.form.checklist = this.form.checklist.slice(0, this.form.checklist.length - 1);
            } else {
                this.form.checklist = [
                    ...this.form.checklist,
                    {
                        isCompleted: false,
                        title: null,
                    },
                ];
            }
        },
        deleteCheckbox(index) {
            this.form.checklist = this.form.checklist.filter((c, i) => i !== index);
        },
        addNewSubtask(isExits) {
            if (
                this.form.subTasks[this.form.subTasks.length - 1] &&
                (this.form.subTasks[this.form.subTasks.length - 1].isExits
                    ? !this.form.subTasks[this.form.subTasks.length - 1].taskId
                    : !this.form.subTasks[this.form.subTasks.length - 1].title)
            ) {
                this.form.subTasks = this.form.subTasks.slice(0, this.form.subTasks.length - 1);
            } else {
                this.form.subTasks = [
                    ...this.form.subTasks,
                    isExits
                        ? {
                              isExits,
                              taskId: null,
                          }
                        : {
                              completed: false,
                              assignees: this.users[0]?.value,
                              title: null,
                          },
                ];
            }
        },
        deleteSubtask(index) {
            this.form.subTasks = this.form.subTasks.filter((c, i) => i !== index);
        },
        openAssigne(key) {
            this.assigneOptions[key] = !this.assigneOptions[key];
        },
        bindData() {
            this.form.workflowId = this.defaultWorkflow._id;
            this.form.pipelineStageId = this.defaultWorkflow.pipeline.find((pipeline) => pipeline.type == "todo")?._id;
        },
    },
    mounted() {
        if(this.details.taskId){
            this.getTaskDetail(this.details.taskId).then((data) => {
                console.log("data geldi", {
                    data,
                })
                this.form = data;
            });
        }
        this.bindData();
    },
    watch: {
        form: {
            deep: true,
            handler() {
                this.$emit("update-form", this.form);
            },
        },
        defaultWorkflow: {
            deep: true,
            handler() {
                this.bindData();
            },
        },
    },
};
</script>
<style lang="scss">
.ant-calendar-picker-container {
    z-index: 999999;
}
#create-task-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .row {
        flex-wrap: nowrap;
        margin-right: 0px;
        margin-left: 0px;
        gap: 10px;
    }
    .row-bracket {
        width: 100%;
        border-bottom: 1px solid #ec4a1d2e;
        margin: 15px 0px;
    }
    .user-assigne {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 10px;
        .select-multiple {
            width: 50%;
        }
        .user-assigne-container {
            display: flex;
            align-items: center;
            gap: 20px;
        }
        .assigne-user-options {
            display: flex;
            align-items: center;
            gap: 20px;
            .assigne-option {
                font-size: 16px;
                font-weight: bold;
                border-bottom: 1px dashed #ec4b1d;
                color: #ec4b1d;
            }
        }
    }
    .classic-new-input {
        padding: 20px;
        background: #f1f1f1;
        border: none;
        color: #3c3c3c;
        font-weight: bold;
        font-size: 14px;
        &:focus {
            border: #ec4a1d65 !important;
            box-shadow: 0 0 0 2px #ffaa0037;
        }
        &::placeholder {
            opacity: 1;
            font-weight: bold;
        }
    }
    .classic-new-select {
        width: 100%;
        font-weight: bold;
        [role="combobox"] {
            padding: 4px;
            border: none !important;
            border-radius: 4px !important;
            background-color: #f1f1f1 !important;
        }
    }
    .user-assigne {
        &-owner,
        &-collaborators,
        &-followers {
            overflow: hidden;
            transition: all 0.4s ease;
            height: 0px;
        }
    }
    .input {
        font-weight: bold;
        .label {
            font-size: 16px;
            margin-bottom: 4px;
        }
        &.title-input {
            width: calc(80% - 10px);
        }
        &.priority-input {
            width: 20%;
        }
    }
    .quill-editor {
        .ql-toolbar.ql-snow {
            background: #f1f1f1;
            border-radius: 4px 4px 0px 0px;
            border: none;
        }
        .ql-container.ql-snow {
            height: 200px;
            max-height: 200px;
            min-height: 200px;
            background: #f1f1f1;
            border-radius: 0px 0px 4px 4px;
            overflow: hidden;
            border: none !important;
        }
    }

    .select-multiple .ant-select-selection {
        border: none !important;
        padding: 5px;
    }
    .checklist-data {
        width: 100%;
        .ant-progress-success-bg,
        .ant-progress-bg {
            background-color: #ec4b1d !important;
        }
        .kanban-checkbox {
            .ant-checkbox-inner {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                &::after {
                    border: 2px solid #fff;
                    left: 20%;
                    width: 7px;
                    height: 11px;
                    border-top: 0;
                    border-left: 0;
                }
            }
            .ant-checkbox.ant-checkbox-checked {
                .ant-checkbox-inner {
                    border: 3px solid #ec4b1d !important;
                    background-color: #ec4b1d !important;
                }
            }
            .ant-checkbox-checked::after {
                border: 1px solid #ec4b1d !important;
            }
            .ant-checkbox-wrapper:hover .ant-checkbox-inner,
            .ant-checkbox:hover .ant-checkbox-inner,
            .ant-checkbox-input:focus + .ant-checkbox-inner {
                border: 1px solid #ec4b1d !important;
            }
        }
    }
    .attach-files {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 240px;
        border: 1px solid #f1f1f1;
        padding: 3px 20px;
        border-radius: 10px;
        margin-top: 15px;
        font-weight: bold;
        .text {
            display: flex;
            align-items: center;
            gap: 10px;
        }
        .logo svg {
            width: 40px;
        }
    }
}
</style>
